export default "__VITE_ASSET__Sa9aCJO6__"